var SupportEditGiftServiceActionView, SupportGiftOrderPopupView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportGiftOrderPopupView = require('../gift_order_popup_view');

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportEditGiftServiceActionView = (function(superClass) {
  extend(SupportEditGiftServiceActionView, superClass);

  function SupportEditGiftServiceActionView() {
    return SupportEditGiftServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportEditGiftServiceActionView.prototype.id = 'gift_to_friend';

  SupportEditGiftServiceActionView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.order = Groupon.Support.currentOrder;
    return this.attributes = this.options.userId;
  };

  SupportEditGiftServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportEditGiftServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: 'edit_gift',
      service_action: I18n.t("js.modules.support.edit_gift")
    };
    return this.extendHash(hash);
  };

  SupportEditGiftServiceActionView.prototype.actionHandler = function(event) {
    var current_order, url;
    current_order = Groupon.Support.currentOrder;
    url = "/users/" + currentUser.id + "/gift_cards";
    window.open(url);
    return this.popup = new SupportGiftOrderPopupView();
  };

  SupportEditGiftServiceActionView.prototype.events = {
    "click #edit_gift": "actionHandler"
  };

  return SupportEditGiftServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportEditGiftServiceActionView;

//# sourceMappingURL=data:application/json;base64,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
